<template>
  <el-container id="header">
    <el-header class="fixed" style="height: 70px">
      <el-row type="flex" justify="space-between">
        <el-col :span="6">
          <img class="logo" src="@/assets/images/header-logo.png" alt="logo">
        </el-col>
        <el-col :span="18">
          <a href="http://ifopendata.cn/introduction_en" style="float: right;display: inline-block; padding: 0; color: #4AAC35; text-decoration:none; font-size: 18px; padding-top: 5px;">EN</a>
          <el-menu
            @select="handleSelect"
            :default-active="$route.path"
            mode="horizontal"
            menu-trigger="click"
            style="margin-top: 5px; float: right; margin-right: 22px"
            active-text-color="#2aa55e"
            text-color="#505962">
            <el-menu-item index="home">
              数林指数
            </el-menu-item>
            <el-menu-item index="report">
              数林报告
            </el-menu-item>
            <!-- <el-menu-item index="compare">
              比较
            </el-menu-item> -->
            <el-submenu index="/opendata">
              <template slot="title">
                <span style="font-size:large;font-weight:bold">
                  数林四库
                </span>
              </template>
              <el-menu-item style="font-size:15px;font-weight: 400" index="/opendata">
                数据库
              </el-menu-item>
               <el-menu-item style="font-size:15px;font-weight: 400;" index="/policy">
                政策库
              </el-menu-item>
              <el-menu-item style="font-size:15px;font-weight: 400" index="/paper">
                文献库
              </el-menu-item>
              <el-menu-item style="font-size:15px;font-weight: 400;" index="/case">
                案例库
              </el-menu-item>
              <!-- <el-menu-item style="font-size:15px;font-weight: 400; color: #b4b4b4;" index="/forth_dev" >
                第四库（开发中）
              </el-menu-item> -->
            </el-submenu>
            <el-menu-item index="activity">
              数林速递
            </el-menu-item>
            <el-menu-item index="about">
              数林伙伴
            </el-menu-item>
          </el-menu>
        </el-col>
      </el-row>

    </el-header>
    <el-row id="mobile-header" class="hidden-sm-and-up">
      <el-collapse v-model="name" accordion @change="handleChange">
        <el-collapse-item name="1">
          <template slot="title">
            <el-row id="mobile-navbar" type="flex" justify="space-between" align="middle">
              <img class="logo" src="@/assets/images/logo.svg" alt="logo">
              <i :class="iconClass"></i>
            </el-row>
          </template>
          <el-menu
            @select="handleSelect"
            :default-active="activeIndex"
            mode="vertical"
            style="z-index: 99"
            text-color="#2c3e50">
            <el-menu-item v-for="(menu) in menus" :key="menu.id" :index="menu.id">
              {{menu.label}}
            </el-menu-item>
          </el-menu>
        </el-collapse-item>
      </el-collapse>
    </el-row>
  </el-container>
</template>

<script>
export default {
  name: 'MainHeader',
  data () {
    return {
      activeIndex: 'opendata',
      name: '0',
      menus: [
        {
          outer: 1, // 1外部,0内部
          path: `${process.env.IFOPENDATA_URL}`,
          id: 'home',
          label: '数林指数'
        },
        {
          outer: 1,
          path: `${process.env.IFOPENDATA_URL}/report`,
          id: 'report',
          label: '数林报告'
        },
        {
          outer: 1,
          path: `${process.env.IFOPENDATA_URL}/compare`,
          id: 'compare',
          label: '比较'
        },
        {
          outer: 0,
          path: '/opendata',
          id: '/opendata',
          label: '数据库'
        },
        {
          outer: 0,
          path: '/paper',
          id: '/paper',
          label: '文献库'
        },
        {
          outer: 0,
          path: '/policy',
          id: '/policy',
          label: '政策库'
        },
        {
          outer: 0,
          path: '/case',
          id: '/case',
          label: '案例库'
        },
        {
          outer: 1,
          path: `${process.env.IFOPENDATA_URL}/activity`,
          id: 'activity',
          label: '数林速递'
        },
        {
          outer: 1,
          path: `${process.env.IFOPENDATA_URL}/about`,
          id: 'about',
          label: '数林伙伴'
        }
      ],
      opened: false
    }
  },
  props: {
    currentPath: {
      type: String,
      default: '/'
    }
  },
  mounted () {
  },
  computed: {
    iconClass () {
      return this.opened ? 'el-icon-menu is-opened' : 'el-icon-menu'
    }
  },
  methods: {
    handleSelect (val) {
      const menu = this.menus.find(x => x.id === val)
      if (menu.outer === 1) {
        window.location.href = menu.path
      } else {
        this.activeIndex = val
        const location = {path: val}
        this.$router.push(location)
      }
    },
    handleChange () {
      this.opened = !this.opened
    }
  }
}
</script>

<style scoped>
.logo {
  height: 60px;
  padding-left: 2%;
  padding-top: 4px;
  display: block;
}
.logo-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.header_row {
  display: flex;
  justify-content: space-between;
}
.el-icon-menu {
  transition: all .8s;
  transform: rotate(0deg);
}

.el-menu-item {
  font-size: 18px;
  font-weight: bold;
  font-family: 'HanSansCN';
}
.el-icon-menu.is-opened {
  transform: rotate(45deg);
}
#mobile-header {
  padding: 0 1rem;
}
#mobile-header .logo{
  width: 3rem;
  height: 3rem;
}
#header .el-menu {
  border: none;
}
#mobile-navbar {
  height: 100%;
}
#mobile-navbar i {
  font-size: 1.5rem;
}
.fixed {
  position: fixed;
  z-index: 100;
  width: 100%;
  background: #fff;
  box-shadow: 0 1px 15px #666;
  min-width: 1375px;
}
</style>
<style>
.el-menu--popup {
  min-width: 110px;
}
.el-submenu__title{
  border-bottom-color: rgb(255,255,255) !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/Header.vue